(function () {
  'use strict';
  if (window.MMMeasurementV1) return;
  var version = '1.2.0';
  var visibleSince = null, visibleMs = 0, interacted = false;
  var qualifiedSent = false, qualifiedPending = false, qualifiedUnconfirmed = false;
  var attempts = 0, transportChecks = 0, nextRetryAt = 0;
  var published = 0, failed = 0, unconfirmed = 0;
  var lastClicks = new Map(), timer = null;
  var qualificationId = null;
  var stopped = false;
  function privacyAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true);
    } catch (_) { return false; }
  }
  // Diagnostic visits and an explicit local opt-out must not enter MM custom-event reports.
  // These controls do not modify Shopify's standard commerce pixels or consent settings.
  function measurementSuppressed() {
    var hostname = String(window.location.hostname || '').toLowerCase();
    if (hostname === 'localhost' || /\.localhost$/.test(hostname) || hostname === '127.0.0.1' || hostname === '[::1]' || hostname === '::1') return true;
    if (/[?&](?:mm_no_track|seo_audit)(?:=|&|$)/.test(window.location.search)) return true;
    try {
      var choice = window.localStorage.getItem('mm_measurement_suppressed_v1');
      return choice === '1' || choice === 'true';
    } catch (_) { return false; }
  }
  function contentLanguage() {
    var root = document.documentElement;
    var language = root && typeof root.getAttribute === 'function' ? root.getAttribute('lang') : '';
    return String(language || 'und').trim().toLowerCase().slice(0, 35) || 'und';
  }
  function productionAllowed() {
    var s = window.Shopify;
    return !!(s && s.theme && String(s.theme.role).toLowerCase() === 'main' && !s.designMode && !measurementSuppressed() && !/[?&](?:preview_theme_id|_fd|pb)=/.test(window.location.search));
  }
  function transportReady() {
    return !!(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function');
  }
  function pageType(path) {
    var base = path.replace(/^\/es(?=\/|$)/, '') || '/';
    if (base === '/') return 'home';
    if (/^\/products\//.test(base)) return 'product';
    if (/^\/collections\//.test(base)) return 'collection';
    if (/^\/blogs\//.test(base)) return 'blog';
    if (/^\/pages\/(?:hot-wheels-(?:casting|variation)-|.+collector-guide)/.test(base)) return 'collector_guide';
    if (/^\/pages\//.test(base)) return 'content';
    if (base === '/search') return 'search';
    return 'other';
  }
  function publicPath(path) { return pageType(path) === 'other' ? '' : path.slice(0, 300); }
  function allowed() {
    return !stopped && productionAllowed() && privacyAllowed() && document.visibilityState === 'visible';
  }
  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'mm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
  }
  function publish(name, extra) {
    if (!allowed() || !transportReady()) return Promise.resolve('blocked');
    var path = publicPath(window.location.pathname);
    if (!path) return Promise.resolve('blocked');
    var data = Object.assign({schema_version: version, page_type: pageType(path), page_path: path,
      language: contentLanguage(),
      traffic_assessment: 'interaction_proxy_not_bot_proof'}, extra);
    try {
      return Promise.resolve(window.Shopify.analytics.publish(name, data)).then(function (accepted) {
        if (accepted === false) { failed += 1; return 'rejected'; }
        if (accepted === true) { published += 1; return 'accepted'; }
        unconfirmed += 1; return 'unconfirmed';
      }, function () { failed += 1; return 'rejected'; });
    } catch (_) { failed += 1; return Promise.resolve('rejected'); }
  }
  function clearTimer() { if (timer !== null) window.clearTimeout(timer); timer = null; }
  function elapsed() { return visibleMs + (visibleSince === null ? 0 : Math.max(0, Date.now() - visibleSince)); }
  function stopClock() {
    if (visibleSince !== null) visibleMs += Math.max(0, Date.now() - visibleSince);
    visibleSince = null; clearTimer();
  }
  function arm(delay) {
    if (timer !== null || !allowed()) return;
    timer = window.setTimeout(function () { timer = null; qualify(); }, Math.max(0, delay));
  }
  function qualify() {
    if (qualifiedSent || qualifiedUnconfirmed || qualifiedPending || attempts >= 3 || !interacted || !allowed()) return;
    if (!publicPath(window.location.pathname)) return;
    if (elapsed() < 10000) { arm(10000 - elapsed()); return; }
    if (Date.now() < nextRetryAt) { arm(nextRetryAt - Date.now()); return; }
    if (!transportReady()) {
      if (transportChecks < 15) { transportChecks += 1; nextRetryAt = Date.now() + 2000; arm(2000); }
      return;
    }
    clearTimer();
    qualificationId = qualificationId || eventId();
    qualifiedPending = true; attempts += 1;
    publish('mm:qualified_page_visit', {mm_event_id: qualificationId, visible_time_bucket: '10s_plus',
      qualification: 'trusted_interaction_visible_10s_proxy'}).then(function (result) {
      qualifiedPending = false;
      if (result === 'accepted') { qualifiedSent = true; stopClock(); }
      else if (result === 'unconfirmed') { qualifiedUnconfirmed = true; stopClock(); }
      else if (attempts < 3 && allowed()) {
        nextRetryAt = Date.now() + 2000 * attempts; arm(2000 * attempts);
      }
    });
  }
  function startClock() {
    if (!allowed() || qualifiedSent || qualifiedUnconfirmed || attempts >= 3) return;
    if (visibleSince === null) visibleSince = Date.now();
    if (elapsed() < 10000) arm(10000 - elapsed());
    else qualify();
  }
  function resetConsentWindow() {
    stopClock(); visibleMs = 0; interacted = false; lastClicks.clear();
    transportChecks = 0; nextRetryAt = 0; startClock();
  }
  function onInteraction(event) {
    if (!event.isTrusted || !allowed()) return;
    interacted = true; startClock(); qualify();
  }
  function onClick(event) {
    onInteraction(event);
    if (!event.isTrusted || !allowed()) return;
    var target = event.target;
    var link = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
    if (!link) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    var targetType = pageType(url.pathname);
    if (targetType !== 'product' && targetType !== 'collection') return;
    var key = url.pathname, now = Date.now();
    if (lastClicks.has(key) && now - lastClicks.get(key) < 1000) return;
    lastClicks.set(key, now);
    if (lastClicks.size > 50) lastClicks.delete(lastClicks.keys().next().value);
    var sourceType = pageType(window.location.pathname);
    publish(sourceType === 'blog' || sourceType === 'collector_guide' ? 'mm:research_to_shop_click' : 'mm:commercial_link_click',
      {mm_event_id: eventId(), target_type: targetType, target_path: publicPath(url.pathname), interaction: 'trusted_link_click'});
  }
  window.MMMeasurementV1 = Object.freeze({version: version, status: function () {
    return {version: version, productionAllowed: productionAllowed(), analyticsAllowed: privacyAllowed(),
      measurementSuppressed: measurementSuppressed(), contentLanguage: contentLanguage(),
      transportReady: transportReady(), dispatchAccepted: published, dispatchFailed: failed, dispatchUnconfirmed: unconfirmed,
      qualifiedPageAttempted: attempts > 0, qualifiedPageConfirmed: qualifiedSent, qualifiedPagePending: qualifiedPending,
      qualifiedPageUnconfirmed: qualifiedUnconfirmed, qualifiedPageAttempts: attempts, reportingSinkVerified: false};
  }});
  document.addEventListener('click', onClick, {capture: true, passive: true});
  document.addEventListener('pointerdown', onInteraction, {passive: true});
  document.addEventListener('keydown', onInteraction, {passive: true});
  document.addEventListener('visibilitychange', function () { stopClock(); startClock(); });
  document.addEventListener('visitorConsentCollected', resetConsentWindow);
  window.addEventListener('pagehide', function () { stopped = true; stopClock(); });
  window.addEventListener('pageshow', function () { stopped = false; startClock(); });
  startClock();
  if (!window.Shopify || !window.Shopify.customerPrivacy) {
    var shopify = window.Shopify;
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) { if (!error) resetConsentWindow(); });
    }
  }
}());
